import { render } from "./StudentMostAchievements.vue?vue&type=template&id=7c1d93ab"
import script from "./StudentMostAchievements.vue?vue&type=script&lang=js"
export * from "./StudentMostAchievements.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mda/www/akademia-taletow/spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__